import { createAction, props } from "@ngrx/store";
import { IFinantialExpensesReport } from "src/app/shared/interfaces/finantial-expenses-report/ifinantial-expenses-report";

enum FinantialExpensesReportActionType {
    LOAD_FINANTIAL_EXPENSES_REPORT = '[despesa financeiro] load notas fiscais report from api',
    LOAD_FINANTIAL_EXPENSES_REPORT_SUCCESS = '[despesa financeiro] load notas fiscais report from api return success'
}


const loadFinantialExpensesReport = createAction(
    FinantialExpensesReportActionType.LOAD_FINANTIAL_EXPENSES_REPORT
);

const loadFinantialExpensesReportSuccess = createAction(
    FinantialExpensesReportActionType.LOAD_FINANTIAL_EXPENSES_REPORT_SUCCESS,
    props<{ finantial_expenses_report: IFinantialExpensesReport }>()
);

export const finantialExpensesReportActions = {
    loadFinantialExpensesReport,
    loadFinantialExpensesReportSuccess
}